import { Navigate } from 'react-router-dom'
import { useLoadedFlagValue } from '../../utils/sharedHooks'
import { FEATURE_FLAG_KEYS } from '../../features/OpenFeature'
import Referrals from '../../features/Referrals'
import { Loader } from '../BaseComponents'

export const ConditionalReferralsRoute = () => {
  const isReferralExperienceEnabled = useLoadedFlagValue(
    FEATURE_FLAG_KEYS.referralExperienceEnabled,
    false
  )

  if (isReferralExperienceEnabled === null) {
    return <Loader />
  }

  if (isReferralExperienceEnabled === false) {
    return <Navigate replace to="/dashboard" />
  }

  return <Referrals />
}
